export default __webpack_public_path__ + "static/media/bored-babes-banner.ea2d8c35.png";